"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconRemove = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("../Icon/SvgWrapper");
const IconRemove = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  d: "M9 9.5v9c0 .281-.219.5-.5.5h-1a.494.494 0 01-.5-.5v-9c0-.281.219-.5.5-.5h1c.281 0 .5.219.5.5zm4 0v9c0 .281-.219.5-.5.5h-1a.494.494 0 01-.5-.5v-9c0-.281.219-.5.5-.5h1c.281 0 .5.219.5.5zm4 0v9c0 .281-.219.5-.5.5h-1a.494.494 0 01-.5-.5v-9c0-.281.219-.5.5-.5h1c.281 0 .5.219.5.5zm2 11.313V6H5v14.813c0 .75.422 1.187.5 1.187h13c.078 0 .5-.437.5-1.187zM8.5 4h7l-.75-1.828A.603.603 0 0014.484 2H9.531a.526.526 0 00-.265.172L8.5 4zm14.5.5v1c0 .281-.219.5-.5.5H21v14.813C21 22.53 19.875 24 18.5 24h-13C4.125 24 3 22.594 3 20.875V6H1.5a.494.494 0 01-.5-.5v-1c0-.281.219-.5.5-.5h4.828l1.094-2.61C7.734.626 8.672 0 9.5 0h5c.828 0 1.766.625 2.078 1.39L17.672 4H22.5c.281 0 .5.219.5.5z"
}));
exports.IconRemove = IconRemove;
//# sourceMappingURL=IconRemove.js.map